export default "$rounded: (\n  'sm': $border-radius-root / 3,\n  'lg': $border-radius-root * 2\n);\n";